import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as candidateAction from '../actions/candidate.action';
import {map, switchMap, catchError, mergeMap, take, withLatestFrom, filter} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {isNullOrUndefined} from 'util';
import {CandidateService} from '../../candidate.service';


@Injectable()
export class CandidateEffect {
  constructor(private actions: Actions, private candidateService: CandidateService, private store: Store<fromStore.AppState>) {
  }

  @Effect()
  getAllCandidates: Observable<Action> = this.actions.ofType(candidateAction.GET_ALL_CANDIDATES)
    .pipe(
      switchMap(() => {
        return this.candidateService.getAllCandidates()
          .map(res => new candidateAction.GetAllCandidatesSuccess(res))
          .catch(error => of(new candidateAction.GetAllCandidatesError(error)));
      })
    );

  @Effect()
  getCandidate: Observable<Action> = this.actions.ofType(candidateAction.GET_CANDIDATE)
    .pipe(
      withLatestFrom(
        // select candidates.
        this.store.select(state => state.candidatesFeature.candidates.entities),
        (action: any, candidates) => {
          // if no candidates present, proceed for API.
          if (isNullOrUndefined(candidates)) {
            return action;
          } else {
            // brands exists in store.
            const candidate = candidates.filter(c => c.id === action.payload)[0];
            if (!!candidate) {
              // if required candidate is present in store, then return;
              return undefined;
            } else {
              // if required candidate not present in store, then proceed for API.
              return action;
            }
          }
        }
      ),
      filter(action => !!action),
      mergeMap(action => {
        return this.candidateService.getCandidate(action.payload)
          .map(res => new candidateAction.GetCandidateSuccess(res))
          .catch(error => of(new candidateAction.GetCandidateError((error))));
      })
    );

  @Effect()
  deleteCandidate: Observable<Action> = this.actions.ofType(candidateAction.DELETE_CANDIDATE)
    .pipe(
      map((action: candidateAction.DeleteCandidate) => action.payload),
      switchMap(candidateId => {
        return this.candidateService.deleteCandidate(candidateId)
          .map(r => new candidateAction.DeleteCandidateSuccess())
          .catch(e => of(new candidateAction.DeleteCandidateError(e)));
      })
    );

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/candidates/store/effects/candidate.effect.ts